module.exports = __webpack_public_path__ + "img/product_service16.dba6195a.png";